import React, { useEffect, useRef } from 'react'
import { useNavigate, useParams } from 'react-router'
import { useLocation, useSearchParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import Loading from '../../components/Loading'
import Box from '../../components/Box'
import { authenticateUser, authorizeUserWithOauth } from '../App/AppActions'
import DeclinedOAuthPrompt from '../../components/DeclinedOAuthPrompt'
import {
  eraseCookieForOauthCode,
  getCookie,
  getCookieForOauthCode,
  setCookieForOauthCode,
  setCookie
} from '../../global/cookies'

const SignupHandler = props => {
  let { provider } = useParams()
  const [searchParams, setSearchParams] = useSearchParams()
  const navigate = useNavigate()
  const dispath = useDispatch()
  const providerMapForAuth = new Map([['outlook', 'azure']])
  const authRequestStarted = useRef(false)

  useEffect(() => {
    if (searchParams.has('code')) {
      searchParams.delete('code')
      setSearchParams(searchParams)
    }
  }, [])

  useEffect(() => {
    // const {
    //   match: {
    //     params: { provider }
    //   },
    //   history,
    //   history: {
    //     location: { search }
    //   },
    //   authenticateUser,
    //   authorizeUserWithOauth
    // } = this.props

    provider = providerMapForAuth.has(provider)
      ? providerMapForAuth.get(provider)
      : provider

    const parsedState = JSON.parse(window.atob(searchParams.get('state')))

    const oauthCode = getCookieForOauthCode()
    const isAuthorizationFlow = Boolean(
      parsedState && parsedState.query && parsedState.query.isAuthorization
    )

    eraseCookieForOauthCode()

    const redirectToAfterLogin =
      parsedState.query &&
      parsedState.query.redirect &&
      !parsedState.query.reauth
        ? parsedState.query.redirect
        : null

    const oauthCodeFromQuery = searchParams.get('code')
    const finalOauthCode = oauthCodeFromQuery || oauthCode

    if (!oauthCode && oauthCodeFromQuery) {
      setCookieForOauthCode(oauthCodeFromQuery)
    }

    if (finalOauthCode && !authRequestStarted.current) {
      authRequestStarted.current = true
      // /auth/authorize requires the token issued by a previous /auth/login (or
      // /auth/signup) call. Without it we must run the login step first.
      const hasAuthorizeToken = Boolean(getCookie('tempAuthToken'))
      const shouldAuthorizeDirectly = isAuthorizationFlow && hasAuthorizeToken
      const params = {
        provider,
        secret: finalOauthCode,
        method: 'oauth'
        // history
      }

      if (
        parsedState.query.reauth ||
        (isAuthorizationFlow && !hasAuthorizeToken)
      ) {
        params.reauth = true
      }

      if (
        isAuthorizationFlow &&
        (provider === 'google' ||
          provider === 'yahoo' ||
          provider === 'aol' ||
          provider === 'azure')
      ) {
        params.email = parsedState.query.email
      }
      const authPromise = shouldAuthorizeDirectly
        ? authorizeUserWithOauth({
            ...params,
            redirectToAfterLogin
          })
        : authenticateUser(
            { ...params, redirectToAfterLogin },
            null,
            dispath,
            searchParams
          )
      authPromise
        .then(() => {
          setCookie('reload', 'true')
          setTimeout(() => window.close(), 2000)
        })
        .catch(err => {
          setCookie('reload', 'true')
          setTimeout(() => window.close(), 2000)
        })
    }
  }, [searchParams])

  // const {
  //   location: {search},
  //   match: {
  //     params: {provider}
  //   }
  // } = this.props

  const error = searchParams.get('error')

  return error ? (
    <DeclinedOAuthPrompt provider={provider} />
  ) : (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      flexDirection="column">
      <Loading icon />
    </Box>
  )
}

export default SignupHandler
